import logoLight from "../images/logo_value_marktdaten.png";
import logoDark from "../images/logo_value_marktdaten_dark.png";
import {useRevaSelector} from "../redux/revaHooks";
import {selectDarkTheme} from "../redux/themeSlice";
import HeaderUserMenu from "./widgets/HeaderUserMenu";

/**
 * App Header stub (before/while static data is loaded).
 */
function HeaderStub() {
    const isDarkTheme = useRevaSelector(selectDarkTheme);

    return (
        <header className="AppHeader grow-0">
            <div className="flex p-0 bg-surface-50 dark:bg-surface-950">
                <div className="AppHeaderLogo grow-0 shrink-0 px-4 py-6 self-center flex justify-center w-80">
                    <img
                        src={isDarkTheme ? logoDark : logoLight}
                        className={"App-logo m-auto"}
                        height="74"
                        alt="LOGO"
                    />
                </div>
                <div className="AppHeaderTitle grow px-4 py-1 mt-2 self-center">
                    <span className="text-3xl">Real Estate Valuation Assistant</span>
                </div>
                <div className="AppHeaderUser grow-0 shrink-0 p-4 self-center">
                    <HeaderUserMenu />
                </div>
            </div>
        </header>
    );
}

export default HeaderStub;
